import React, { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Link, { LinkPropType } from "../../../link/link";
import ClickSuggestion from "./click-suggestion";
import { useNavigate } from "react-router-dom";
import useTranslate from "@default/hooks/use-translate";

const ParagraphClickSuggestions = ({ content, forceSameTab }) => {
  const clickSuggestions = useRef();
  const navigate = useNavigate();
  const _t = useTranslate();

  const sectionClassNames = classNames({
    "paragraph paragraph-click-suggestions": true,
  });

  return (
    <section
      className={sectionClassNames}
      data-darkmode={content.fieldDarkMode}
      ref={clickSuggestions}
    >
      <div className="container">
        <div className="row">
          {content.fieldHeading && (
            <div className="col-12">
              <h2 className="module-headline">{content.fieldHeading}</h2>
            </div>
          )}
        </div>
        <ul className="ctas row">
          {content.fieldClickSuggestions &&
            content.fieldClickSuggestions.map(
              (link, index) =>
                link && (
                  <li
                    className={classNames({
                      "cta-wrapper col-12 col-sm-10 col-md-6 col-lg-5": true,
                      highlighted: link.fieldHighlighted,
                      standard: !link.fieldHighlighted,
                    })}
                    key={index}
                    style={
                      link.fieldMainColors
                        ? {
                            "--bg-color": `var(--c-${link.fieldMainColors})`,
                          }
                        : undefined
                    }
                  >
                    {link.navigateBack ? (
                      <button
                        onClick={() => navigate(-1)}
                        aria-label={`Back to: ${
                          link.fieldHeading || "last page"
                        }`}
                      >
                        <ClickSuggestion content={link} />
                      </button>
                    ) : (
                      <Link
                        link={link.fieldLink}
                        ariaLabel={`${_t("accessibility.link_to")} ${
                          link.fieldHeading || link?.fieldLink?.title
                        }`}
                        forceSameTab={forceSameTab}
                      >
                        <ClickSuggestion content={link} />
                      </Link>
                    )}
                    {/* Text needs to be outside to ensure it can be marked and can contain links. Otherwise there would be nested links */}
                    {link.fieldText && (
                      <div className="highlighted-text col">
                        <div
                          className="text"
                          dangerouslySetInnerHTML={{
                            __html: link.fieldText,
                          }}
                        />
                      </div>
                    )}
                  </li>
                )
            )}
        </ul>
      </div>
    </section>
  );
};

ParagraphClickSuggestions.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldHeading: PropTypes.string,
    fieldDarkMode: PropTypes.bool,
    fieldClickSuggestions: PropTypes.arrayOf(
      PropTypes.shape({
        fieldHeading: PropTypes.string,
        fieldSubline: PropTypes.string,
        fieldMainColors: PropTypes.string,
        fieldImage: PropTypes.object,
        fieldLink: PropTypes.shape({
          url: PropTypes.shape({
            routed: PropTypes.bool,
            path: PropTypes.string,
          }),
        }),
      })
    ),
  }),
};

export default ParagraphClickSuggestions;
